import { LandingSource } from '../types'

export const stringBySource = (source: LandingSource) => {
  switch (source) {
    case 'payrolldatalandingpage':
      return 'Payroll Landing'
    default:
      return source
  }
}
